const fonyFamilyVariables = new Map<string, { var: string; cssVar: string; assignDefault?: string[] }>([
  [
    'fontFamily',
    {
      var: 'fontFamily.default',
      cssVar: 'font-family-default',
    },
  ],
]);

export default fonyFamilyVariables;
